
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

import useDatawinDataModelItem from '../../hooks/useDatawinDataModelItemId';
import { getActions } from '../../sagas';
import { getDataModelDefinition } from '../../reducers'

const COMBOBOX_LABEL_STYLES = {
    label: {
        color: getTheme().palette.neutralTertiary
    }
};

const DataModelItemCombobox = () => {

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const dataModelDefinition = useSelector(state => getDataModelDefinition(state.data));
    const dataModelItemId = useDatawinDataModelItem();

    const handleChange = (e, item) => {                
        dataActions.setDatawinDataModelItemId(item.key);
    }

    const getOptions = () => {
        let options = [];

        let items = dataModelDefinition.dataModelDefinition.items.reduce((previous, current) => {
            if (current.operations.get && (current.$template !== true)) {
                previous.push(current);
            }
            return previous;
        }, []);

        options = [
            ...options,
            ...items.map(item => {
                return {
                    key: item.id,
                    text: item.title
                }
            })
        ];
        return options;
    }
    
    let readOnly = false;

    return (
        <ComboBox            
            disabled={readOnly}
            onChange={handleChange}
            options={getOptions()}
            placeholder="Vyberte typ objektu"
            readOnly={readOnly}
            selectedKey={dataModelItemId}
            styles={COMBOBOX_LABEL_STYLES}
        />
    );
}

export default DataModelItemCombobox;
